import { TheMask } from 'vue-the-mask'

export default {
  TheMask
}



// WEBPACK FOOTER //
// ./src/app/dweller/livings/resources/components.js